import areaService from '@/services/area.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		areas: [],
		area: {},
		roundAreas: [],
		searchParams: {
			name: '',
			customerId: '',
			mapId: '',
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_AREAS(state, areas) {
			state.areas = areas;
		},
		SET_AREA(state, area) {
			state.area = area;
		},
		SET_ROUND_AREAS(state, areas) {
			state.roundAreas = areas;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		SET_MAPID(state, mapId) {
			state.searchParams.mapId = mapId;
		}
	},

	actions: {
		async getArea({ commit }, areaId) {
			return await areaService
				.getArea(areaId)
				.then(data => {
					commit('SET_AREA', data);
				})
				.catch(err => {
					console.log('Error getting area: ', err);
				});
		},
		async getAreas({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await areaService
				.getAreas(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_AREAS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getAreas');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting areas: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getAllAreas({ commit, dispatch }, params) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				name: params.search,
				customerId: params.customerId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 1000
			};

			return await areaService
				.getAreas(searchParams)
				.then(data => {
					commit('SET_AREAS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting areas: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getRoundAreas({ commit, dispatch }, roundPlanningId) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				roundPlanningId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 1000
			};

			return await areaService
				.getAreas(searchParams)
				.then(data => {
					commit('SET_ROUND_AREAS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting areas: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createArea({ dispatch }, area) {
			return await areaService
				.createArea(area)
				.then(() => {
					dispatch('getAreas');
				})
				.catch(err => {
					console.log('Error creating area: ', err);
				});
		},
		async updateArea({ dispatch }, area) {
			return await areaService
				.updateArea(area)
				.then(() => {
					dispatch('getAreas');
				})
				.catch(err => {
					console.log('Error updating area: ', err);
				});
		},
		async deleteArea({ dispatch }, area) {
			return await areaService
				.deleteArea(area.id)
				.then(() => {
					dispatch('getAreas');
				})
				.catch(err => {
					console.log('Error deleting area: ', err);
				});
		},

		setArea({ commit }, area) {
			commit('SET_AREA', area);
		},
		setAreas({ commit }, areas) {
			commit('SET_AREAS', areas);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		},
		setAreaMapId({ commit }, mapId) {
			commit('SET_MAPID', mapId);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		areas: state => {
			return state.areas;
		},
		dropdownAreas: state => {
			return state.dropdownAreas;
		},
		roundAreas: state => {
			return state.roundAreas;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		},
		selectedArea: state => {
			return state.selectedArea;
		}
	}
};
